import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldTypeKind} from '../enum/field.type.kind';

@EntityTable('cluster', '4091bebb-3114-4bf7-bc5b-418e6c5d1b1e')
export class ClusterEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

}
